<template>
    <DashboardLayout :user="user">
        <div class="border border-gray-300 bg-white rounded-lg shadow-lg max-w-4xl mx-auto pb-10">
            <!-- Header: My Accounts (Aligned Left) -->
            <div class="bg-gray-200 text-lg font-semibold px-6 py-3 rounded-t-lg text-left">
                Fund Transfer
            </div>

            <div class="px-6 py-4 flex space-x-4">
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'beneficiary' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('beneficiary')">
                    Beneficiaries
                </button>
                <button 
                    class="px-6 py-2 rounded-full shadow-md font-semibold"
                    :class="activeTab === 'add_beneficiary' ? 'bg-primary text-white' : 'bg-gray-300 text-gray-700'"
                    @click="navigateTo('add_beneficiary')">
                    Add Beneficiary
                </button>
            </div>

            <div v-if="activeTab === 'beneficiary'">
                <BeneficiaryDetails :user="user" />
            </div>
            <div v-else-if="activeTab === 'add_beneficiary'">
                <AddBeneficiary :user="user" />
            </div>

            
        </div>
    </DashboardLayout>

</template>

<script>


import DashboardLayout from "@/components/DashboardLayout.vue";
import BeneficiaryDetails from "./BeneficiaryDetails.vue";
import AddBeneficiary from "./AddBeneficiary.vue";

export default {
    name: 'MyAccounts',
    components: {
        DashboardLayout, BeneficiaryDetails, AddBeneficiary
    },
    data() {
        return {
            user: {},
            activeTab: 'beneficiary'
        };
    },
    computed:{
        currentComponent(){
            return this.activeTab == 'beneficiary' ? 'BeneficiaryDetails' : 'AddBeneficiary';
        }
    },
    created() {
        const userData = localStorage.getItem('user');
        if (!userData) {
            alert("Session expired. Please log in again.");
            this.$router.push("/");
            return;
        }
        this.user = JSON.parse(userData);

        if (this.$route.path === "/beneficiary") this.activeTab = "beneficiary";
        else this.activeTab = "add_beneficiary";
    },
    watch: {
        // Watch for URL changes and update the active tab
        "$route.path"() {
            this.updateTabFromRoute();
        }
    },
    methods: {
        navigateTo(tab) {
            this.activeTab = tab;
            const routes = {
                beneficiary: "/beneficiary",
                add_beneficiary: "/add-beneficiary",
            };
            this.$router.push(routes[tab]);
        },
        updateTabFromRoute() {
            if (this.$route.path === "/beneficiary") {
                this.activeTab = "beneficiary";
            } else {
                this.activeTab = "add_beneficiary";
            }
        }
    }
}

</script>
